import { Box, styled } from "@mui/material"

export const InviteButton = styled(Box)<{ margin: string }>(
  ({ theme, margin }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "56px",
    textAlign: "center",
    lineHeight: "46px",
    paddingTop: "20px",
    paddingBottom: "10px",
    width: "100%",
    margin: margin,
    color: `${theme.palette.primary.main}`,
    background: `${theme.palette.mockup.primary95}`,
    cursor: "pointer",
    boxShadow: "0px 0px 0px rgba(210, 218, 249, 0.25)",
    ":hover": {
      transition: ".2s",
      background: theme.palette.primary.light,
    },
    ":focus-visible": {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: "-2px",
    },
  })
)
